(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emeltec-combobox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emeltec-combobox')) {
    const fold = (text) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

    customElements.define(
      'emeltec-combobox',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.list = this.querySelector('[role="listbox"]');
          this.options = [...this.list.querySelectorAll('[role="option"]')];
          this.empty = this.list.querySelector('.emeltec-combobox__empty');
          this.active = -1;

          this.input.addEventListener('input', () => {
            this.filter();
            this.open();
            this.syncValidity();
          });
          this.input.addEventListener('focus', () => {
            this.filter();
            this.open();
          });
          this.input.addEventListener('blur', () => {
            this.close();
            // Accept a typed value that matches an option except for case or accents
            const match = this.options.find((option) => fold(option.textContent) === fold(this.input.value));
            if (match) this.input.value = match.textContent;
            this.syncValidity();
          });
          this.input.addEventListener('keydown', (event) => this.onKey(event));

          this.querySelector('.emeltec-combobox__toggle').addEventListener('mousedown', (event) => {
            event.preventDefault();
            if (this.list.hidden) {
              this.input.focus();
              this.filter(true);
              this.open();
            } else {
              this.close();
            }
          });
          // mousedown keeps focus in the input so blur does not close the list before the pick
          this.list.addEventListener('mousedown', (event) => {
            event.preventDefault();
            const option = event.target.closest('[role="option"]');
            if (option) this.pick(option);
          });

          this.syncValidity();
        }

        visible() {
          return this.options.filter((option) => !option.hidden);
        }

        filter(showAll = false) {
          const query = showAll ? '' : fold(this.input.value);
          const exact = this.options.some((option) => fold(option.textContent) === query);
          this.options.forEach((option) => {
            // With a value already picked, show the whole list again so it can be changed
            option.hidden = Boolean(query) && !exact && !fold(option.textContent).includes(query);
          });
          this.empty.hidden = this.visible().length > 0;
          this.highlight(-1);
        }

        open() {
          this.list.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
        }

        close() {
          this.list.hidden = true;
          this.input.setAttribute('aria-expanded', 'false');
          this.highlight(-1);
        }

        highlight(index) {
          const visible = this.visible();
          this.options.forEach((option) => option.setAttribute('aria-selected', 'false'));
          this.active = index;
          if (index < 0 || !visible[index]) {
            this.input.removeAttribute('aria-activedescendant');
            return;
          }
          visible[index].setAttribute('aria-selected', 'true');
          visible[index].scrollIntoView({ block: 'nearest' });
          this.input.setAttribute('aria-activedescendant', visible[index].id);
        }

        pick(option) {
          this.input.value = option.textContent;
          this.close();
          this.syncValidity();
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.close();
        }

        onKey(event) {
          const visible = this.visible();
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            if (this.list.hidden) this.open();
            const step = event.key === 'ArrowDown' ? 1 : -1;
            this.highlight((this.active + step + visible.length) % visible.length);
          } else if (event.key === 'Enter' && !this.list.hidden) {
            const target = visible[this.active] || (visible.length === 1 ? visible[0] : null);
            if (target) {
              event.preventDefault();
              this.pick(target);
            }
          } else if (event.key === 'Escape') {
            this.close();
          }
        }

        syncValidity() {
          const value = this.input.value.trim();
          const valid = !value || this.options.some((option) => option.textContent === value);
          this.input.setCustomValidity(valid ? '' : 'Elige una opción de la lista.');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
